/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForZabbix extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForZabbix");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForZabbix.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForZabbix>): ServiceAccountNativeDetailsForZabbix {
        let obj = Object.assign(new ServiceAccountNativeDetailsForZabbix(), model);
        ServiceAccountNativeDetailsForZabbix.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForZabbix>): ServiceAccountNativeDetailsForZabbix {
        if (!model) return null;
        return ServiceAccountNativeDetailsForZabbix.newInstance(<ServiceAccountNativeDetailsForZabbix> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForZabbix) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForZabbix.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForZabbix): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForZabbix.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.configuration) {
            for (let val of this.configuration) {
                models.ZabbixConfiguration.fixupPrototype(val);
            }
        }
        if (this.host_configuration) {
            for (let val of this.host_configuration) {
                models.ZabbixHostConfiguration.fixupPrototype(val);
            }
        }
    }

    /**
     * Configuration for Zabbix Management
     */
    configuration: Array<models.ZabbixConfiguration>;

    /**
     * Host Configuration for Zabbix Management
     */
    host_configuration: Array<models.ZabbixHostConfiguration>;

}
